import React from 'react';
import { productShortName } from '../data/offer';
export function Footer() {
  return <footer className="bg-slate-950 text-slate-300" data-id="element-69" data-mp="3gezdb400vr15">
      <div className="h-px w-full bg-sky-400" aria-hidden="true" data-id="element-70" data-mp="3ggu1qsai619z" />
      <div className="mx-auto max-w-3xl px-4 py-8 text-center" data-id="element-71" data-mp="32onkt3zizq9h">
        <p className="text-xs" data-id="element-72" data-mp="36pft9v0kpr4p">© 2026 {productShortName}. Tutti i diritti riservati.</p>
      </div>
    </footer>;
}